import {
  Box,
  useMediaQuery,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useRef, useState } from 'react';
import { ref, getDownloadURL, getStorage } from 'firebase/storage';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../actions';
import moment from 'moment';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import {
  adjustPercentages,
  getKpiNotificationsByMonth,
  getKpiOtherNotificationsByMonth,
  getColorForData,
  getTime,
  fetchDataFromAPIAndFirestore,
  createStorageData,
  storeDataInLocalStorage,
  removeOldKpiStorageKeys,
  getKpiAltasByMonth,
  getLocalDataKpiStorageAnual,
} from '../helpers';
import { isEmpty } from 'lodash';
import ScrollButtons from './ScrollButtons';
import { ModalForceUpdateKpi } from './ModalForceUpdateKpi';
import WarningIcon from '@mui/icons-material/Warning';
import KpiWithInfo from './KpiWithInfo';
import { handleErrorSwal } from '../../../shared/swals';
const useStyles = (small) => {
  return makeStyles((theme) => ({
    kpi: {
      cursor: 'pointer',
      paddingBlock: 16,
      width: 'fit-content',
      minWidth: '200px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 32,
      marginBottom: 32,
      color: '#857979',
      transition: '.3s all',
      '&:hover': {
        transform: 'scale(1.2)',
        position: 'relative',
        zIndex: 3,
      },
    },
    kpiSelected: {
      transform: 'scale(1.2)',
      position: 'relative',
      zIndex: 3,
    },
    kpiTitle: {
      paddingBlock: 4,
      fontSize: 18,
    },
    kpiValue: {
      fontSize: theme.sizes.lg.t1,
      fontWeight: 'light',
    },
    kpiSubValue: {
      fontSize: 28,
      fontWeight: 'light',
    },
    kpiSubRef: {
      fontSize: theme.sizes.sm.t2,
    },
    kpiDivider: {
      width: '100%',
    },
    kpiBody: {
      minHeight: '85px',
    },
    chartRef: {
      color: '#484848',
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 'bold',
    },
    horizontalScrollWrapper: {
      position: 'relative',
      width: '100%',
    },
    horizontalScroll: {
      display: 'flex',
      overflow: 'hidden',
      width: '100%',
      position: 'relative',
      '& > div': {
        flex: '0 0 auto',
      },
    },
    arrowButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: '#fff',
      border: 'none',
      cursor: 'pointer',
      padding: '8px',
      zIndex: 2,
    },
    leftArrow: {
      left: '-2rem',
    },
    rightArrow: {
      right: '-2rem',
    },
  }));
};

const options = {
  // indexAxis: 'x',
  // elements: {
  //   bar: {
  //     borderWidth: 2,
  //   },
  // },
  responsive: true,
  // plugins: {
  //   legend: {
  //     position: 'right',
  //   },
  // },
};

const defaultChart = {
  labels: [],
  datasets: [
    {
      data: [],
      backgroundColor: [],
    },
  ],
};
function Kpis() {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();

  // hooks
  // redux
  const appDispatch = useDispatch();
  const firestore = useFirestore();
  const scrollRef = useRef(null);
  const organization = useSelector((state) => state.app.organization);
  const profile = useSelector((state) => state.firebase.profile);
  const prestobotsConfig = useSelector((state) => state.app.prestobotsConfig);
  const graphicsDescriptions = useSelector((state) => state.app.graphicsDescriptions);

  const isAdmin = profile && profile.claims && profile.claims.includes('admin');

  // states
  const [chatsData, setChatsData] = useState(defaultChart);
  const [notificationsData, setNotificationsData] = useState(defaultChart);
  const [otherNotificationsData, setOtherNotificationsData] = useState(defaultChart);
  const [altasData, setAltasData] = useState(defaultChart);
  const [times, setTimes] = useState([]);
  const [date, setDate] = useState('');
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [nextUpdateDate, setnextUpdateDate] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  const labels = {
    gestiones: [],
    chats: [],
    notifications: [],
    otherNotifications: [],
    altasData: [],
  };
  const datasets = {
    gestiones: [],
    chats: [],
    notifications: [],
    otherNotifications: [],
    altasData: [],
  };
  const coloresNotificaciones = [];
  const coloresChats = [];
  const coloresOtherNotifications = [];
  const coloresAltas = [];

  const updateThresholdInDays = 7;
  // effects
  useEffect(() => {
    setArrayOfTimes();
  }, []);

  useEffect(() => {
    setArrayOfTimes();
  }, [organization.id]);

  useEffect(() => {
    const dateFromTimes = `${times[0]}`;
    const stringToMoment = dateFromTimes.replace(/(\d{4})-(\d{2})/, '$1/$2/01');
    if (date === '' || !date._isValid) {
      setDate(moment(new Date(stringToMoment)));
    }
  }, [times]);

  useEffect(() => {
    date._isValid && fetchAndHandleData();
  }, [date]);

  useEffect(() => {
    const updateOverflow = () => {
      setIsOverflowing(scrollRef.current.scrollWidth > scrollRef.current.clientWidth);
    };

    updateOverflow();
    window.addEventListener('resize', updateOverflow);

    return () => {
      window.removeEventListener('resize', updateOverflow);
    };
  }, [scrollRef?.current?.scrollWidth]);

  // methods
  const fetchAndHandleData = async () => {
    let data, nextUpdateDate;
    try {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: true, priority: 2 },
      });
      let dataKpiStorageAnual = getLocalDataKpiStorageAnual();
      const initialDate = date.format('YYYY-MM');
      const dataKey = `${initialDate}${organization.id}`;
      let dataKpiStorage = dataKpiStorageAnual?.[dataKey] || {};
      if (
        prestobotsConfig.enableKpiForceUpdate ||
        !dataKpiStorage ||
        dataKpiStorage.initialDate !== initialDate ||
        (dataKpiStorage.lastCheckedDate &&
          moment().diff(dataKpiStorage.lastCheckedDate, 'days') > updateThresholdInDays)
      ) {
        const apiResponse = await fetchDataFromAPIAndFirestore(
          initialDate,
          organization.id,
          firestore,
        );
        dataKpiStorage = createStorageData({
          ...apiResponse,
          organizationId: organization.id,
          initialDate,
        });
        dataKpiStorageAnual = removeOldKpiStorageKeys(dataKpiStorageAnual);
        storeDataInLocalStorage(
          'dataKpiStorageAnual',
          dataKey,
          dataKpiStorage,
          dataKpiStorageAnual,
        );
        nextUpdateDate = moment().add(updateThresholdInDays, 'days').format('DD-MM-YYYY');
      } else {
        nextUpdateDate = moment(dataKpiStorage.lastCheckedDate)
          .add(updateThresholdInDays, 'days')
          .format('DD-MM-YYYY');
      }
      data = dataKpiStorage.data;
      handleKpisData(data);
      setnextUpdateDate(nextUpdateDate);
      await fetchGraphicsDescriptions();
      appDispatch({
        type: actions.kpiDate,
        kpiDate: moment(initialDate),
      });
    } catch (error) {
      console.error('fetchAndHandleData', error);
      // Ante un error borramos el almacenamiento ya que este puede contener data obsoleta o con configuraciones erroneas
      // eslint-disable-next-line no-undef
      localStorage.removeItem('dataKpiStorageAnual');
      handleErrorSwal();
    } finally {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: false, priority: 2 },
      });
    }
  };

  const fetchGraphicsDescriptions = async () => {
    if (isEmpty(graphicsDescriptions)) {
      try {
        const storage = getStorage();
        const fileName = `dashboardGraphicsDescriptions.json`;
        const route = `configuration/${fileName}`;
        const agentsRef = ref(storage, route);
        const url = await getDownloadURL(agentsRef);

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Failed to fetch graphics descriptions');
        }

        const graphicsDescriptionsResponse = await response.json();
        appDispatch({
          type: actions.graphicsDescriptions,
          graphicsDescriptions: graphicsDescriptionsResponse,
        });
      } catch (error) {
        console.error('fetchGraphicsDescriptions', error);
      }
    }
  };
  const handleKpisData = (data) => {
    const { kpiChats, gestionesNotificacionesRes, gestionesKpiChartsRes } = data;
    const kpiNotificacionesRes = getKpiNotificationsByMonth(gestionesNotificacionesRes);
    const kpiActivacionAlta = getKpiOtherNotificationsByMonth(gestionesNotificacionesRes);
    const kpiAltas = getKpiAltasByMonth(gestionesKpiChartsRes);

    processAndFormatKpiData(
      kpiActivacionAlta,
      'GESTION',
      'TOTAL',
      'otherNotifications',
      coloresOtherNotifications,
    );
    processAndFormatKpiData(kpiAltas, 'GESTION', 'TOTAL', 'altasData', coloresAltas);
    handleChatsData(kpiChats);
    handleNotificationsData(kpiNotificacionesRes, kpiChats);

    setKpisData();
  };

  const processAndFormatKpiData = (data, labelKey, totalKey, dataType, colorArray) => {
    if (data && !isEmpty(data)) {
      const adjustedData = adjustPercentages(data, labelKey, totalKey);
      adjustedData.forEach((item, index) => {
        labels[dataType].push(`${item[labelKey]} (${item.percentage}%)`);
        colorArray.push(getColorForData(dataType === 'gestiones' ? item[labelKey] : index + 1));
        datasets[dataType].push(item[totalKey]);
      });
    }
  };

  const handleNotificationsData = (data, billingData) => {
    if (data && !isEmpty(data)) {
      const totalRecordatorios = billingData.totalsFromGupshup.totalRecordatorios;
      const adjustedData = adjustPercentages(data, 'reminderResponse', 'total');
      let sumOfDatasets = 0;
      adjustedData.forEach((item, index) => {
        const calculatedNotificationValue = ((item.percentage * totalRecordatorios) / 100).toFixed(
          0,
        );
        labels.notifications.push(`${item.reminderResponse} (${item.percentage}%)`);
        coloresNotificaciones.push(getColorForData(item.reminderResponse));
        datasets.notifications.push(Number(calculatedNotificationValue));
        sumOfDatasets += Number(calculatedNotificationValue);

        if (index === adjustedData.length - 1 && sumOfDatasets !== totalRecordatorios) {
          const adjustment = totalRecordatorios - sumOfDatasets;
          datasets.notifications[index] += adjustment;
        }
      });
    }
  };
  const handleChatsData = (kpiChats) => {
    let chatsWpp;
    let chatsWeb;
    if (kpiChats && !isEmpty(kpiChats)) {
      if (kpiChats.isV2) {
        chatsWpp = kpiChats.totalsFromGupshup.totalUic;
        chatsWeb = kpiChats.chatsWeb;
      } else if (kpiChats.whatsapp || kpiChats.webchat) {
        chatsWpp = kpiChats.whatsapp || 0;
        chatsWeb = kpiChats.webchat || 0;
      }
      const adjustedData = adjustPercentages(
        [
          { chat: 'Whatsapp', total: chatsWpp },
          { chat: 'Webchat', total: chatsWeb },
        ],
        'chat',
        'total',
      );
      adjustedData.forEach((item) => {
        labels.chats.push(`${item.chat.toUpperCase()} (${item.percentage}%)`);
        coloresChats.push(getColorForData(item.chat));
        datasets.chats.push(item.total);
      });
    }
  };
  const setArrayOfTimes = async () => {
    try {
      const res = await firestore
        .collection(collections.bills)
        .where('organizationId', '==', organization.id)
        .get();

      if (res.empty) {
        setTimes([]);
        return;
      }

      const dates = res.docs.map((doc) => doc.data());
      const _date = moment();
      const initialBilling = organization?.billingData?.initial;
      let _times = dates
        .sort((a, b) => {
          const dateA = moment(a.date);
          const dateB = moment(b.date);
          return dateA < dateB ? 1 : -1;
        })
        .slice(0, 10)
        .map((e) => e.date);

      if (initialBilling && (initialBilling === 1 || initialBilling > _date.get('date'))) {
        _times = _times.filter((e) => e !== _date.clone().add(1, 'month').format('YYYY-MM'));
      }
      setDate('');
      setTimes(_times);
    } catch (err) {
      console.error('setArrayOfTimes', err);
    }
  };

  const setKpisData = () => {
    setChatsData({
      labels: labels.chats,
      datasets: [
        {
          data: datasets.chats,
          backgroundColor: coloresChats,
        },
      ],
    });

    setNotificationsData({
      labels: labels.notifications,
      datasets: [
        {
          data: datasets.notifications,
          backgroundColor: coloresNotificaciones,
        },
      ],
    });

    setOtherNotificationsData({
      labels: labels.otherNotifications,
      datasets: [
        {
          data: datasets.otherNotifications,
          backgroundColor: coloresOtherNotifications,
        },
      ],
    });

    setAltasData({
      labels: labels.altasData,
      datasets: [
        {
          data: datasets.altasData,
          backgroundColor: coloresAltas,
        },
      ],
    });
  };

  return (
    <Box display="flex" flexWrap="wrap" my={4}>
      <Box display="flex" mb={4} style={{ width: '100%', justifyContent: 'space-between' }}>
        <Box style={{ width: '200px' }}>
          <FormControl fullWidth>
            <InputLabel>Seleccione período</InputLabel>
            <Select
              value={date !== '' ? date.format('YYYY-MM') : date}
              label="Seleccione período"
              onChange={(e) => {
                setDate(moment(new Date(`${e.target.value.replace('-', '/')}/01`)));
              }}
            >
              {times &&
                times.map((time) => (
                  <MenuItem className={classes.selectItem} key={time} value={time}>
                    {getTime(time)}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <Typography variant="caption" color="textSecondary">
            Próxima Actualización: {nextUpdateDate}
          </Typography>
        </Box>
        {isAdmin && (
          <Box display="flex" style={{ flexDirection: 'column' }}>
            <Button
              variant="contained"
              color="primary"
              sx={{ fontSize: '0.8rem', padding: '16px 32px', height: '65%', mb: '.5rem' }}
              onClick={() => setModalOpen(true)}
            >
              Forzar Actualizacion
            </Button>
            <Typography
              variant="caption"
              color={prestobotsConfig.enableKpiForceUpdate ? 'error' : 'textSecondary'}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {prestobotsConfig.enableKpiForceUpdate && <WarningIcon style={{ marginRight: 4 }} />}
              Actualización forzosa:{' '}
              {prestobotsConfig.enableKpiForceUpdate ? 'Activada' : 'Desactivada'}
            </Typography>
          </Box>
        )}
      </Box>
      <Box className={classes.horizontalScrollWrapper}>
        <ScrollButtons scrollRef={scrollRef} isOverflowing={isOverflowing} />
        <Box className={classes.horizontalScroll} ref={scrollRef}>
          <Box
            display="flex"
            justifyContent="space-around"
            flexDirection={small ? 'column' : 'row'}
            style={{ width: '100%' }}
          >
            <KpiWithInfo
              data={chatsData}
              options={options}
              title="Chats por tipo"
              infoText={graphicsDescriptions?.kpis?.chatDistributionByChannel}
              classes={classes}
            />
            <KpiWithInfo
              data={notificationsData}
              options={options}
              title="Recordatorios"
              infoText={graphicsDescriptions?.kpis?.reminderStatusOverview}
              classes={classes}
            />
            <KpiWithInfo
              data={otherNotificationsData}
              options={options}
              title="Plantillas"
              infoText={graphicsDescriptions?.kpis?.templateUsageRatio}
              classes={classes}
            />
            <KpiWithInfo
              data={altasData}
              options={options}
              title="Altas"
              infoText={graphicsDescriptions?.kpis?.altasStatusOverview}
              classes={classes}
            />
          </Box>
        </Box>
      </Box>
      {isAdmin && (
        <ModalForceUpdateKpi
          prestobotsConfig={prestobotsConfig}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
        />
      )}
    </Box>
  );
}

export default Kpis;
